import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'FeatureList',
})(({ brandColors, spacing, breakpoints, typography }, props) => ({
  featureListRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: `${spacing(2)} 0`,
  },
  featureItem: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: spacing(3),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  featureContent: {
    paddingRight: spacing(2),
    marginRight: 0,
    borderRight: darkOrLightStyle(props)(
      `${typography.pxToRem(1)} solid rgba(255, 255, 255, 0.30)`,
      `${typography.pxToRem(1)} solid rgba(0, 0, 0, 0.20)`
    ),
    [breakpoints.up('md')]: {
      width: typography.pxToRem(192),
      marginRight: spacing(4),
      '&:last-child': {
        marginRight: 0,
      },
    },
  },
  featureBody: {
    marginTop: spacing(0),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  singleFeatureList: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: spacing(3),
  },
}));

export default useStyles;
